export const ROUTES = {
  PHONE_VERIFICATION_LINK_REGISTER: "/",
  SUCCESS: "/sucess",
};
